import {
    ADD_CANDIDATE_FEEDBACK_REQUEST,
    ADD_CANDIDATE_FEEDBACK_SUCCESS,
    ADD_CANDIDATE_FEEDBACK_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addCandidateFeedBackReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CANDIDATE_FEEDBACK_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_CANDIDATE_FEEDBACK_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_CANDIDATE_FEEDBACK_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addCandidateFeedBackReducer;
